import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-a-down-circle",
  "use": "icon-a-down-circle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-arrow-down-circle\" id=\"icon-a-down-circle\"><circle cx=\"12\" cy=\"12\" r=\"10\" /><polyline points=\"8 12 12 16 16 12\" /><line x1=\"12\" y1=\"8\" x2=\"12\" y2=\"16\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol